<template>
    <div class="gh-card gh-card--course">
        <figure class="gh-card__image" ref="cardImage"></figure>
        <div class="gh-card__body">
            <h3 class="course__title">{{ course.title }}</h3>
            <slot name="excerpt"></slot>
            <div class="course__details">
                <ul class="course__meta">
                    <li class="meta__item">
                        <span class="meta__icon"><i class="fa fa-hourglass" aria-hidden="true"></i></span>
                        <span class="meta__label">Duration</span>
                        <span class="meta__data">{{ course.duration }}</span>
                    </li>
                    <li v-if="! isCredential" class="meta__item">
                        <span class="meta__icon"><i class="fa fa-stack-overflow" aria-hidden="true"></i></span>
                        <span class="meta__label">Format</span>
                        <span class="meta__data">{{ course.format }}</span>
                    </li>
                    <li class="meta__item">
                        <span class="meta__icon"><i class="fa fa-cogs" aria-hidden="true"></i></span>
                        <span class="meta__label">Type</span>
                        <span class="meta__data">{{ courseType }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gh-card__actions">
            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            course: {
                type: Object,
                required: true
            }
        },

        mounted() {
            const cardImage = new Image();
            const vm = this;

            cardImage.src = this.course.links.image;

            cardImage.onload = function() {
                if (vm.$refs.cardImage) {
                    vm.$refs.cardImage.style.backgroundImage = `url(${this.src})`;
                }
            }
        },

        computed: {
            isCredential () {
                return this.course.isCredential
            },

            courseType () {
                return this.isCredential ? 'Digital Credential' : this.course.level
            }
        }
    }
</script>
<style lang="scss" scoped>
.gh-card--course {
    cursor: default;
}

</style>
